import { Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { AGGridCellRenderParams } from "../types";
import { toYesterdayOrToday } from "./util";

interface Props {
  params: AGGridCellRenderParams;
}

export const DateRenderer = ({ params }: Props) => {
  const dateText = toYesterdayOrToday(params.value);
  const showSubValue = dateText === "Yesterday" || dateText === "Today" ? true : false;
  return (
    <>
      <Text css={{ paddingTop: SPACING.SMALL }} marginBottom="xs">
        {showSubValue ? dateText : params.value}
      </Text>
      {showSubValue && (
        <Text marginBottom="sm" variant="secondary-sm">
          {params.value}
        </Text>
      )}
    </>
  );
};
